import React, { useState } from "react";
import { Phone, Mail, MapPin, Info } from "lucide-react";
import { FaInstagram, FaLinkedinIn, FaFacebookF } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ContactUs = () => {
  const fullUrl = window.location.href;
  const [formData, setFormData] = useState({
    name: "",
    mobile: "",
    remark: "",
    user_id: "HBTR0001",
    enquiry_source: "Contact Page",
    source: fullUrl,
    main_id: "HBTR0001",
  });
  const url = process.env.REACT_APP_LINK;
  const [errors, setErrors] = useState({});
  const [submittedOnce, setSubmittedOnce] = useState(false);
  const [load, setLoad] = useState(true);

  const URL = `${process.env.REACT_APP_LINK}`;
  const validateField = (name, value) => {
    if (name === "name") return value.trim() === "";
    if (name === "mobile") return value.length !== 10;
    if (name === "remark") return value.trim() === "";
    return false;
  };

  const handleChange = (e) => {
    let { name, value } = e.target;

    if (name === "mobile") {
      value = value.replace(/\D/g, "");
      if (value.startsWith("91") && value.length > 10) value = value.slice(2);
      else if (value.startsWith("0") && value.length > 10)
        value = value.slice(1);
      value = value.slice(0, 10);
    }

    setFormData({ ...formData, [name]: value });

    if (submittedOnce) {
      setErrors((prev) => ({ ...prev, [name]: validateField(name, value) }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmittedOnce(true);

    const nameError = validateField("name", formData.name);
    const mobileError = validateField("mobile", formData.mobile);
    const remarkError = validateField("remark", formData.remark);

    const newErrors = {
      name: nameError,
      mobile: mobileError,
      remark: remarkError,
    };
    setErrors(newErrors);

    if (nameError || mobileError || remarkError) {
      toast.error("Please fix the highlighted fields.");
      return;
    }

    setLoad(false);
    try {
      const response = await fetch(`${url}/contact`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success("Details sent! Our team will contact you soon.");
        setFormData({
          name: "",
          mobile: "",
          remark: "",
          user_id: "HBTR0001",
          enquiry_source: "Contact Page",
          source: fullUrl,
        });
        setErrors({});
        setSubmittedOnce(false);
      } else {
        toast.error("Submission failed, try again.");
      }
    } catch (error) {
      toast.error("Network error, try again later.");
    } finally {
      setLoad(true);
    }
  };

  const renderInputWithIcon = (id, name, type, placeholder, value) => (
    <div className="form-group-fb" style={{ position: "relative" }}>
      <label htmlFor={id}>{placeholder}</label>
      <input
        id={id}
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        className={errors[name] ? "input-error" : ""}
        style={{ paddingRight: "35px" }}
      />
      {errors[name] && (
        <Info
          size={18}
          className="input-icon"
          style={{
            position: "absolute",
            right: "10px",
            top: "40px",
            pointerEvents: "none",
            color: "red",
          }}
        />
      )}
    </div>
  );

  return (
    <section className="contact-container-fb">
      <ToastContainer position="top-center" autoClose={3000} />
      <div className="contact-header-fb">
        <h1 className="contact-title-fb">Connect with us</h1>
        <p className="contact-subtitle-fb">
          Get in touch for personalized real estate services.
        </p>
      </div>

      <div className="contact-content-fb">
        <div className="contact-form-fb">
          <h2 className="contact-section-title-fb">Send a Message</h2>
          <form onSubmit={handleSubmit}>
            {renderInputWithIcon(
              "name",
              "name",
              "text",
              "Your Name",
              formData.name,
            )}
            {renderInputWithIcon(
              "mobile",
              "mobile",
              "tel",
              "Your Phone Number",
              formData.mobile,
            )}

            <div className="form-group-fb" style={{ position: "relative" }}>
              <label htmlFor="remark">Message</label>
              <textarea
                id="remark"
                name="remark"
                placeholder="Your Message"
                rows={5}
                value={formData.remark}
                onChange={handleChange}
                className={errors.remark ? "input-error" : ""}
                style={{ paddingRight: "35px" }}
              />
              {errors.remark && (
                <Info
                  size={18}
                  className="input-icon"
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "40px",
                    pointerEvents: "none",
                    color: "red",
                  }}
                />
              )}
            </div>

            <button type="submit" className="submit-btn-fb" disabled={!load}>
              {load ? "Send Inquiry" : "Sending..."}
            </button>
          </form>
        </div>

        <div className="contact-info-fb">
          <h2 className="contact-section-title-fb">Visit or Reach Out</h2>
          <div className="contact-item-fb">
            <Mail className="contact-icon-fb" size={24} />
            <p>
              <strong>Email:</strong> v9homes@gmail.com
              <br />
            </p>
          </div>
          <div className="contact-item-fb">
            <MapPin className="contact-icon-fb" size={24} />
            <p>
              <strong>Office:</strong> Shop No 15, Swapnpurti Chs Ltd, Thakur
              Village, Opposite Viceroy Savana, Kandivali East, Mumbai - 400101
              <br />
            </p>
          </div>
          <div className="contact-item-fb">
            <Phone className="contact-icon-fb" size={24} />
            <p>
              <strong>Call:</strong>+91 9323794100
            </p>
          </div>
          {/* <div className="contact-item-fb">
            <Mail className="contact-icon-fb" size={24} />
            <p><strong>Email:</strong> info@sarfareproperties.com</p>
          </div> */}

          <div className="socials">
            <div className="social-icons">
              <a
                href="https://www.instagram.com/V9 Homes/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#E4405F" }}
                className="social-icon-brand"
              >
                <FaInstagram />
              </a>
              <a
                href="https://www.linkedin.com/company/V9 Homes/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#0A66C2" }}
                className="social-icon-brand"
              >
                <FaLinkedinIn />
              </a>
              <a
                href="https://www.facebook.com/V9 Homes/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "#1877F2" }}
                className="social-icon-brand"
              >
                <FaFacebookF />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="contact-map-fb">
        <iframe
          title="Map to Sarfare Properties"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2703.0322744774085!2d72.866717388855!3d19.214155500000007!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b736cddae007%3A0x969c3a6c8ae7e0b!2sSwapnapurti!5e1!3m2!1sen!2sin!4v1773848490141!5m2!1sen!2sin"
          width="100%"
          height="350px"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
};

export default ContactUs;
